<template>

	<!-- Main Sidebar -->
	<a-layout-sider
		collapsible
		class="sider-primary"
		breakpoint="lg"
		collapsed-width="0"
		width="250px"
		:collapsed="sidebarCollapsed"
		@collapse="$emit('toggleSidebar', ! sidebarCollapsed)"
		:trigger="null"
		:class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme]"
		theme="light"
		:style="{ backgroundColor: 'transparent',}">
			<div class="brand"><img src="images/logo-ct-black.png" alt=""> <span>Meeting tool</span></div>
			<hr>

			<!-- Sidebar Navigation Menu -->
			<a-menu theme="light" mode="inline">
				<a-menu-item>
					<router-link to="/dashboard" @click="closeOnMobile">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill="#111827"/>
								<path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill="#111827"/>
								<path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Dashboard</span>
					</router-link>
				</a-menu-item>

				<a-menu-item>
					<router-link to="/projects" @click="closeOnMobile">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M2 5C2 4.44772 2.44772 4 3 4H7.5L9 6H17C17.5523 6 18 6.44772 18 7V15C18 15.5523 17.5523 16 17 16H3C2.44772 16 2 15.5523 2 15V5Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Dự án</span>
					</router-link>
				</a-menu-item>

				<!-- <a-menu-item>
					<router-link to="/huong-dan" @click="closeOnMobile">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M4 3C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V4C17 3.44772 16.5523 3 16 3H4ZM6 6.5C6 6.22386 6.22386 6 6.5 6H13.5C13.7761 6 14 6.22386 14 6.5V7.5C14 7.77614 13.7761 8 13.5 8H6.5C6.22386 8 6 7.77614 6 7.5V6.5ZM6.5 10C6.22386 10 6 10.2239 6 10.5V11.5C6 11.7761 6.22386 12 6.5 12H11.5C11.7761 12 12 11.7761 12 11.5V10.5C12 10.2239 11.7761 10 11.5 10H6.5Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Hướng dẫn sử dụng</span>
					</router-link>
				</a-menu-item> -->

			</a-menu>
			<!-- / Sidebar Navigation Menu -->

			<!-- User (đáy sidebar) -->
			<div class="sidebar-user">
				<a-dropdown placement="top" :trigger="['click']">
					<template #overlay>
						<a-menu>
							<a-menu-item>
								<router-link to="/huong-dan" @click="closeOnMobile">
									<span class="label">Hướng dẫn sử dụng</span>
								</router-link>
							</a-menu-item>
							<a-menu-item key="change-password" @click="onChangePassword">Đổi mật khẩu</a-menu-item>
							<a-menu-item key="logout" @click="onLogout">Đăng xuất</a-menu-item>
						</a-menu>
					</template>
					<div class="user-box">
						<span class="user-avatar">
							<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z" fill="currentColor"/>
							</svg>
						</span>
						<span class="user-name">{{ authStore.user?.name || 'Người dùng' }}</span>
						<svg class="user-caret" width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M5 12.5L10 7.5L15 12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
				</a-dropdown>
			</div>

	</a-layout-sider>
	<!-- / Main Sidebar -->

	<!-- Change Password Modal -->
	<a-modal
		v-model:open="showChangePasswordModal"
		title="Đổi mật khẩu"
		@ok="handleChangePasswordOk"
		@cancel="handleChangePasswordCancel"
	>
		<a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
			<a-form-item label="Mật khẩu cũ" required><a-input type="password" /></a-form-item>
			<a-form-item label="Mật khẩu mới" required><a-input type="password" /></a-form-item>
			<a-form-item label="Xác nhận mật khẩu mới" required><a-input type="password" /></a-form-item>
		</a-form>
	</a-modal>

</template>

<script>

	import { ref } from 'vue'
	import { useAuthStore } from '@/stores'
	import router from '@/router'

	export default ({
		emits: ['toggleSidebar'],
		props: {
			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},

			// Main sidebar color.
			sidebarColor: {
				type: String,
				default: "primary",
			},

			// Main sidebar theme : light, white, dark.
			sidebarTheme: {
				type: String,
				default: "light",
			},
		},
		setup(props, { emit }) {
			const authStore = useAuthStore()
			const showChangePasswordModal = ref(false)

			const onChangePassword = () => { showChangePasswordModal.value = true }
			const handleChangePasswordOk = () => { showChangePasswordModal.value = false }
			const handleChangePasswordCancel = () => { showChangePasswordModal.value = false }
			const onLogout = () => {
				authStore.logout()
				router.push("/")
			}
			// Tự đóng sidebar khi chọn menu trên mobile
			const closeOnMobile = () => {
				if (typeof window !== 'undefined' && window.innerWidth < 992) {
					emit('toggleSidebar', true)
				}
			}

			return {
				authStore,
				showChangePasswordModal,
				onChangePassword,
				handleChangePasswordOk,
				handleChangePasswordCancel,
				onLogout,
				closeOnMobile,
			}
		},
	})

</script>
